class ProductOtherOffers extends HTMLElement {
  connectedCallback() {
    this.productForm = document.querySelector('[data-product-main-from]');

    if (!this.dataset.productHandle || !this.productForm) {
      return;
    }

    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  #init() {
    new Vue({
      el: this,
      data: {
        productForm: this.productForm,
        productHandle: this.dataset.productHandle,
        product: null,
        productOffers: [],
        refurbishedProducts: {},
        currentVariantId: null,
        addingToCart: null,
      },
      template: `
        <div class="product__other-offers" v-if="productOffers.length">
          <h4 class="product__other-offers-heading">Other offers:</h4>  
          
          <div class="product__other-offers-list">
            <template  v-for="variant in productOffers">
              <div class="product__other-offers-item">
                <div class="image">
                  <img 
                    :srcset="formatImage(variant.image?.originalSrc || variant.featured_image, '140x140', 'center')" 
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    loading="lazy"
                    alt=""
                  >
                </div>
                
                <div class="info">
                  <div class="badge">
                    <span class="refurbished" v-if="variant.isRefurbished">Refurbished</span>
                    <span class="new" v-else>New</span>
                  </div>
                  <div class="price" v-html="formatMoney(variant.price)" />
                  <div class="shipping">
                    <template v-if="variant.isRefurbished">
                      FREE Shipping
                    </template>
                    <template v-else>
                      Ships from China
                    </template>
                  </div>
                </div>
  
                <button
                  class="button button--orange"
                  :class="{ 'button--disabled': !variant.available, 'loading': addingToCart === variant.id }"
                  :disabled="!variant.available"
                  @click.prevent="handleAddToCart(variant)"
                  aria-label="Add to cart"
                  v-html="window.Shopify.icons.bag"
                />
                
                <div class="ships" v-if="getUsuallyShips(variant)">
                  <div class="usually-ships" v-html="getUsuallyShips(variant).replace('<br>', ' ')" />
                </div>

                <a
                 class="preview-photos"
                 href="#"
                 @click.prevent="openGallery(variant.product_images)"
                 v-if="variant.isRefurbished && variant.product_images && variant.product_images.length"
                >
                 Review photos
                </a>
              </div>
            </template>
          </div>
        </div>
      `,

      async mounted() {
        this.setupEventListeners();

        this.product = await Shopify.shopifyService.fetchProduct(this.productHandle);

        const gids = [];

        this.product?.variants.forEach(variant => {
          if (variant.refurbished_product) {
            gids.push(variant.refurbished_product);
          }
        });

        if (gids.length) {
          const response = await Shopify.shopifyService.fetchProducts(gids);
          response.data.nodes
            .filter(node => node)
            .forEach(refurbishedProduct => {
              const refurbishedVariant = refurbishedProduct.variants.edges[0].node;
              refurbishedVariant.id = refurbishedVariant.id.replace('gid://shopify/ProductVariant/', '');
              refurbishedVariant.price = refurbishedVariant.price.amount * 100;
              refurbishedVariant.available = refurbishedVariant.availableForSale;
              refurbishedVariant.name =
                refurbishedProduct.title + ' ' + refurbishedVariant.title.replace('Default Title', '');
              refurbishedVariant.arrives = refurbishedVariant.arrives ? refurbishedVariant.arrives.value : null;
              refurbishedVariant.restock = refurbishedVariant.restock ? refurbishedVariant.restock.value : null;
              refurbishedVariant.ships_from = refurbishedVariant.ships_from
                ? refurbishedVariant.ships_from.value
                : null;
              refurbishedVariant.product_images = [];
              refurbishedVariant.product = {
                id: Number(refurbishedProduct.id.replace('gid://shopify/Product/', '')),
                collections: refurbishedProduct.collections.edges.map(edge => ({
                  id: Number(edge.node.id.replace('gid://shopify/Collection/', '')),
                  handle: edge.node.handle,
                })),
              };

              if (refurbishedVariant.available) {
                const variant = this.product.variants.find(
                  variant => variant.refurbished_product && variant.refurbished_product === refurbishedProduct.id,
                );
                this.refurbishedProducts[variant.id] = refurbishedVariant;
              }
            });

          this.productOffers = this.getProductOffers();
        }
      },

      methods: {
        setupEventListeners() {
          document.addEventListener('product.variant.change', e => {
            this.currentVariantId = e.detail.variantId;
            this.productOffers = this.getProductOffers();
          });

          Shopify.discount.onUpdated(() => {
            this.productOffers = this.getProductOffers();
          });
        },

        getProductOffers() {
          if (!this.product) return [];

          const currentVariant = this.getCurrentVariant();

          const offers = [];
          const variantRefurbished = clone(this.getVariantRefurbished(currentVariant));

          // const variantPlus = clone(this.getVariantPlus(currentVariant));
          // const isComingSoon = this.isComingSoon(currentVariant);

          // if (variantPlus && isComingSoon) {
          // offers.push(variantPlus);
          // }

          if (variantRefurbished) {
            variantRefurbished.isRefurbished = true;
            offers.push(variantRefurbished);
          }

          offers.forEach(variant => {
            const discountCode = Shopify.discount.appliedDiscountCodes.find(code =>
              Shopify.discount.isProductEligibleForDiscount(variant.product, code),
            );

            if (discountCode) {
              variant.price = Shopify.discount.getPriceWithDiscount(variant.price, discountCode);
            }
          });

          return offers;
        },

        getCurrentVariant() {
          const currentVariantId = this.currentVariantId || this.getCurrentVariantId();
          return currentVariantId
            ? this.product.variants.find(variant => variant.id === Number(currentVariantId))
            : this.product.variants[0];
        },

        getVariantRefurbished(currentVariant) {
          return this.refurbishedProducts[currentVariant.id];
        },

        isComingSoon(variant) {
          const shipsFrom = getShipsFrom(variant);
          const isShipsFromChina = shipsFrom ? shipsFrom.toLowerCase().includes('china') : false;
          const isPreOrder = variant.inventory_management !== null && variant.inventory_policy === 'continue' && variant.inventory_quantity < 1;

          if (!isShipsFromChina && isPreOrder) {
            return true;
          }
        },

        getDeadlineForDelivery(variant) {
          const {v110, na, plus} = Shopify.strings;
          const variantRestock = variant.restock;
          const usuallyShips = getUsuallyShips(variant, true);

          let variantArrives = variant.arrives;
          if (
            !variantArrives &&
            (variant.title.includes(v110) || variant.title.includes(na)) &&
            !variant.title.includes(plus) &&
            !usuallyShips
          ) {
            variantArrives = '3-6';
          }

          if (variantArrives) {
            const daysTo = variantArrives.split('-')[1];
            let secondsTo = Date.now() + daysTo * 24 * 60 * 60 * 1000;

            if (
              variantRestock &&
              new Date(variantRestock).getTime() > Date.now() &&
              variant.inventory_management !== null &&
              variant.inventory_quantity < 1
            ) {
              const daysDif = new Date(variantRestock).getTime() - Date.now();
              secondsTo = secondsTo + daysDif;
            }

            return secondsTo;
          }
        },

        getCurrentVariantId() {
          const href = window.location.href;
          const index = href.search(/\?/) + 1;
          const newLocation = href.substr(0, index) + href.slice(index).replace(/\?/g, '&');
          history.pushState(null, null, newLocation);

          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);

          return urlParams.get('variant');
        },

        openGallery(images) {
          if (!images) return;

          const gallery = images.map(image => ({
            src: image,
            thumb: image,
            typer: 'image',
          }));

          if (gallery.length) {
            Fancybox.show(gallery, {infinite: false});
          }
        },

        getDetails(variant) {
          const element = document.querySelector('.product-plug li.active');
          const plugValue = element ? element.dataset.plugValue : null;

          if (plugValue) {
            return `SKU: ${variant.sku || variant.name} - Plug: ${plugValue}`;
          }
        },

        handleAddToCart(variant) {
          if (this.addingToCart) return;
          this.addingToCart = variant.id;

          const formSerialize = serializeForm(this.productForm);
          const details = this.getDetails(variant);

          window.cartDrawer
            .add({
              items: [
                {
                  id: variant.id,
                  quantity: 1,
                  properties: {
                    DETAILS: details,
                  },
                },
              ],
            })
            .then(() => {
              Shopify.cart.setNote(formSerialize.note);
              this.addingToCart = null;
            });
        },
      },
    });
  }
}

customElements.define('product-other-offers', ProductOtherOffers);
